<template>
  <fetch-error
    v-if="error"
    @retry="getAbilities()"
    :error="error"
  ></fetch-error>
  <div v-else class="container">
    <vs-col vs-w="12" class="desc-cont">
      <h3 class="desc">
        لطفا دسترسی های مورد نیاز برای کاربر
        {{ selectedEmployee.phone }} مشخص کنید.
      </h3>
    </vs-col>
    <vs-col vs-w="12">
      <vs-row class="mt-6">
        <vx-card
          v-for="(abilityGroup, index) in abilities"
          :key="index"
          :title="abilityGroup.title"
          class="mb-5 mx-5"
        >
          <div slot="no-body" class="pt-5">
            <vs-col
              vs-w="6"
              v-for="abilityItem in abilityGroup.data"
              :key="abilityItem.id"
              class="ability-item"
            >
              <div @click="() => selectAbility(abilityItem.id)">
                <vs-checkbox v-model="abilityItem.value">{{
                  abilityItem.description
                }}</vs-checkbox>
              </div>
            </vs-col>
          </div>
        </vx-card>
      </vs-row>
    </vs-col>
    <vs-col class="row justify-start">
      <div class="flex justify-end">
        <vs-button
          @click="save()"
          color="primary"
          class="mt-5"
          block
          icon-pack="feather"
          icon="icon-check"
          >ذخیره
        </vs-button>
      </div>
      <div class="flex justify-end ml-5">
        <vs-button
          @click="deleteEmployee()"
          class="mt-5"
          color="danger"
          type="filled"
          >حذف کارمند</vs-button
        >
      </div>
    </vs-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FetchError from "../../components/FetchError.vue";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  components: { FetchError },
  name: "EmployeeAbilities",
  data() {
    return {
      abilities: [],
      selectedAbilities: [],
      error: null,
    };
  },
  mounted() {
    if (this.selectedEmployee) this.getAbilities(this.selectedEmployee.id);
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    getAbilities(employeeId) {
      this.$vs.loading();
      this.selectedAbilities = [];
      this.abilities = [];
      providerApiService
        .getEmployeeAbilities(this.currentProvider.id, employeeId)
        .then((result) => {
          this.setGroupByAbilitiesData(result.data);
          this.initialSelectedAbilities(result.data);
        })
        .catch((err) => (this.error = err))
        .finally(() => this.$vs.loading.close());
    },
    selectAbility(abilityId) {
      //in here you can check what ever condition  before append to array.
      if (this.selectedAbilities.includes(abilityId)) {
        this.selectedAbilities = this.selectedAbilities.filter(
          (item) => item !== abilityId
        );
      } else {
        this.selectedAbilities.push(abilityId);
      }
    },
    initialSelectedAbilities(abilities) {
      abilities.forEach((item) => {
        if (item.value) {
          this.selectedAbilities.push(item.id);
        }
      });
    },
    save() {
      this.$vs.loading();
      providerApiService
        .addAbilities(
          this.currentProvider.id,
          this.selectedEmployee.id,
          this.selectedAbilities
        )
        .then(() => {
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد",
            color: "success",
            position: "bottom-center",
          });
          window.location.reload();
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    deleteEmployee() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `حذف کارمند`,
        text: `از حذف کارمند "${
          this.selectedEmployee.name || this.selectedEmployee.phone
        }" اطمینان دارید؟`,
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => {
          this.$vs.loading();
          providerApiService
            .deleteEmployee(
              this.currentProvider.id,
              this.selectedEmployee.phone
            )
            .then(() => {
              this.$emit("employeeDeleted");
              this.$vs.notify({
                text: "کارمند با موفقیت حذف شد",
                position: "bottom-center",
                color: "success",
              });
            })
            .finally(() => this.$vs.loading.close());
        },
      });
    },
    setGroupByAbilitiesData(data) {
      const ordersAbilities = { title: "سفارشات", data: [] };
      const productsAbilities = { title: "محصولات فروشگاه", data: [] };
      const panelAbilities = { title: "پنل مدیریتی", data: [] };

      data?.forEach((item) => {
        switch (item.scope) {
          case "orders":
            ordersAbilities.id = item.scope;
            ordersAbilities.data.push(item);
            return;
          case "categories":
          case "items":
            productsAbilities.id = item.scope;
            productsAbilities.data.push(item);
            return;
          default:
            panelAbilities.id = item.scope;
            panelAbilities.data.push(item);
            return;
        }
      });

      this.abilities = this.abilities.concat(
        ordersAbilities,
        productsAbilities,
        panelAbilities
      );
    },
  },
  watch: {
    selectedEmployee(employee) {
      this.getAbilities(employee.id);
    },
  },
  props: {
    selectedEmployee: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.ability-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 700px;
  float: left;
}

.desc-cont {
  margin-bottom: 0px;
}

.desc {
  color: #000000;
  font-size: 1.1rem;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
</style>